<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <signal-r
      :path="`/hub/facturas?jwt=${this.token}`"
      @notification-received="updateProgress"
    >
    </signal-r>

    <detalles ref="detalles"></detalles>

    <servidores ref="servidores"></servidores>

    <!-- Diálogo Programa SAT con Tabs -->
    <v-dialog
      v-model="dialogPrograma"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          Herramienta Descarga Masiva
        </v-card-title>
        <v-tabs v-model="tabPrograma" fixed-tabs>
          <v-tab>Descargar</v-tab>
          <v-tab>Cómo usar</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabPrograma">
          <!-- Tab Descargar -->
          <v-tab-item>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="text-body-2">
                    <strong>Versión:</strong> 1.0
                  </div>
                  <div class="text-body-2">
                    <strong>Fecha:</strong> 16/02/2026
                  </div>
                  <div class="text-body-2 mb-4">
                    <strong>Tamaño:</strong> 58 MB
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    @click="descargarPrograma"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Descargar Programa
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>

          <!-- Tab Cómo usar -->
          <v-tab-item>
            <v-card-text>
              <div class="text-body-2">
                <v-img
                  src="/img/descarga_masiva_facturas.png"
                  max-height="600px"
                  contain
                >
                </v-img>
                <ol>
                  <li class="mb-2">Instalar el programa descargado.</li>
                  <li class="mb-2">
                    Seleccionar el archivo de <strong>Certificado (.cer)</strong>.
                  </li>
                  <li class="mb-2">
                    Seleccionar el archivo de <strong>Llave privada (.key)</strong>.
                  </li>
                  <li class="mb-2">
                    Ingresar la <strong>contraseña de la e.firma</strong>.
                  </li>
                  <li class="mb-2">
                    Ejecutar la descarga masiva desde el programa.
                  </li>
                  <li class="mb-2">
                    Al finalizar, el sistema generará un archivo en formato 
                    <strong>.ubga</strong>, el cual deberá cargarse en la plataforma <strong>MiUBGA</strong>.
                  </li>
                  <li class="mb-2">
                    También se generará un archivo de resumen llamado 
                    <strong>resumen_movimiento_{fecha}.xlsx</strong>, con información general de los movimientos.
                  </li>
                  <li class="mb-2">
                    Para revisar el detalle completo de la información, deberá hacerlo desde la plataforma <strong>MiUBGA</strong>.
                  </li>
                  <li class="mb-2">
                    En esta pantalla, utilice el botón <strong>"Cargar Archivo"</strong> para subir el archivo <strong>.ubga</strong>.
                  </li>
                </ol>
              </div>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogPrograma = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Cargando -->
    <v-dialog
      v-model="dialogCargando"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          Procesando facturas...
        </v-card-title>
        <v-card-text>
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>
          <div class="text-center text-body-2">
            Esto puede tardar unos momentos, por favor espere.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Row principal: Carga y Programa -->
    <v-row align="center">
      <v-col cols="12" md="3">
        <v-btn
          color="primary"
          block
          @click="verServidores"
        >
          <v-icon left>mdi-server</v-icon>
          Administrar Servidores de Descarga
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <!-- Espaciador -->
      </v-col>

      <v-col cols="12" md="3">
        <v-btn
          color="primary"
          block
          outlined
          @click="dialogPrograma = true"
        >
          <v-icon left>mdi-download</v-icon>
          <span class="text-center">
            Herramienta<br>Descarga Masiva
          </span>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Row: Última actualización -->
    <v-row>
      <v-col cols="12">
        <div class="text-body-2">
          <strong>Última actualización:</strong> {{ ultima_actualizacion || 'Sin actualizaciones' }}
        </div>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-select
          v-model="filters.tipo"
          :items="opcionesTipo"
          label="Tipo de Factura"
          dense
          outlined
          hide-details
          clearable
        ></v-select>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          v-model="filters.rfc"
          label="RFC (Emisor/Receptor)"
          dense
          outlined
          hide-details
          clearable
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="filters.nombre"
          label="Nombre / Razón Social"
          dense
          outlined
          hide-details
          clearable
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-menu
          v-model="menuFechaDesde"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filters.fecha_emision_desde"
              label="Fecha Desde"
              prepend-inner-icon="mdi-calendar"
              readonly
              dense
              outlined
              hide-details
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.fecha_emision_desde"
            @input="menuFechaDesde = false"
            locale="es-mx"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3">
        <v-menu
          v-model="menuFechaHasta"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filters.fecha_emision_hasta"
              label="Fecha Hasta"
              prepend-inner-icon="mdi-calendar"
              readonly
              dense
              outlined
              hide-details
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.fecha_emision_hasta"
            @input="menuFechaHasta = false"
            locale="es-mx"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          v-model.number="filters.monto_desde"
          label="Monto Mínimo"
          type="number"
          prefix="$"
          dense
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model.number="filters.monto_hasta"
          label="Monto Máximo"
          type="number"
          prefix="$"
          dense
          outlined
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="d-flex align-center">
        <v-checkbox
          v-model="filters.iva_retencion"
          label="Retención IVA"
          hide-details
          class="mt-0 mr-4"
        ></v-checkbox>
        <v-checkbox
          v-model="filters.isr_retencion"
          label="Retención ISR"
          hide-details
          class="mt-0"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" md="6" class="text-right d-flex align-center justify-end">
        <v-btn color="secondary" text @click="limpiarFiltros" class="mr-2">
          Limpiar
        </v-btn>

        <v-btn text color="primary" @click="getItems" :loading="loading">
          <v-icon left>mdi-magnify</v-icon> Buscar
        </v-btn>
        
        <v-btn 
          color="success" 
          class="mr-2" 
          @click="exportarExcel" 
          text
        >
          <v-icon left>mdi-file-excel</v-icon>
          Exportar
        </v-btn>

        
      </v-col>
    </v-row>

    <!-- Row: Tabla de facturas -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="facturas"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.id_uuid_factura`]="{ item }">
            <a
              href="#"
              class="text-decoration-underline"
              @click.prevent="verDetalles(item.id_uuid_factura)"
            >
              {{item.id_uuid_factura}}
            </a>
          </template>
          <template v-slot:[`item.sub_total`]="{ item }">
            ${{ formatMoney(item.sub_total) }}
          </template>
          <template v-slot:[`item.descuento`]="{ item }">
            ${{ formatMoney(item.descuento) }}
          </template>
          <template v-slot:[`item.impuestos`]="{ item }">
            <div class="d-flex align-center flex-wrap" style="gap: 12px;">
              <div
                v-for="(imp, index) in item.impuestos"
                :key="index"
                class="d-flex align-center"
                style="gap: 6px;"
              >
                <!-- Icono individual -->
                <v-tooltip bottom max-width="420">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      color="info"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>

                  <!-- Tooltip individual -->
                  <div>
                    <div><strong>Tipo:</strong> {{ imp.tipo_impuesto }}</div>
                    <div><strong>Impuesto:</strong> {{ imp.impuesto }}</div>
                    <div><strong>Factor:</strong> {{ imp.tipo_factor }}</div>
                    <div><strong>Tasa/Cuota:</strong> {{ (imp.tasa_o_cuota * 100).toFixed(2) }}%</div>
                    <div><strong>Base:</strong> ${{ formatMoney(imp.base) }}</div>
                    <div><strong>Importe:</strong> ${{ formatMoney(imp.importe) }}</div>
                  </div>
                </v-tooltip>

                <!-- Texto visible -->
                <span>
                  {{ imp.impuesto }}: ${{ formatMoney(imp.importe) }}
                </span>
              </div>

              <span v-if="!item.impuestos.length">—</span>

            </div>
          </template>
          <template v-slot:[`item.relaciones`]="{ item }">
            <div class="d-flex align-center flex-wrap" style="gap: 12px;">
              <template v-if="item.relaciones?.length">
                <div
                  v-for="(rel, index) in item.relaciones"
                  :key="rel.id_uuid_factura ?? index"
                  class="d-flex align-center"
                >
                  <v-tooltip bottom max-width="560">
                    <template v-slot:activator="{ on, attrs }">
                      <!-- Disponible => link -->
                      <a
                        v-if="rel.disponible"
                        href="#"
                        v-bind="attrs"
                        v-on="on"
                        class="text-decoration-underline"
                        @click.prevent="verDetalles(rel.id_uuid_factura)"
                      >
                        CFDI #{{ index + 1 }}
                      </a>

                      <!-- No disponible => texto -->
                      <span
                        v-else
                        v-bind="attrs"
                        v-on="on"
                        class="text--disabled"
                      >
                        CFDI #{{ index + 1 }}
                      </span>
                    </template>

                    <!-- Tooltip con detalle -->
                    <div>
                      <div><strong>Tipo de relación:</strong> {{ rel.tipo_relacion }}</div>
                      <div><strong>UUID:</strong> {{ rel.id_uuid_factura }}</div>
                      <div v-if="!rel.disponible" class="mt-1">
                        (No disponible en el sistema)
                      </div>
                    </div>
                  </v-tooltip>
                </div>
              </template>

              <span v-else>—</span>
            </div>
          </template>


          <template v-slot:[`item.total`]="{ item }">
            ${{ formatMoney(item.total) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="verDetalle(item.id_uuid_factura)"
            >
              mdi-eye
            </v-icon>
          </template>

          <template v-slot:[`item.poliza`]="{ item }">
            <div class="align-center" style="min-width:150px; gap:6px;">

              <!-- EDICIÓN -->
              <template v-if="editingPolizaId === item.id_uuid_factura">

                <v-text-field
                  v-model="polizaDrafts[item.id_uuid_factura]"
                  dense
                  outlined
                  hide-details
                  class="ma-0 pa-0"
                  placeholder="Póliza"
                  @keyup.enter="guardarPoliza(item)"
                ></v-text-field>
                <br>

                <div class="d-flex">
                  <v-btn
                    icon
                    small
                    color="success"
                    :loading="savingPoliza"
                    @click="guardarPoliza(item)"
                  >
                    <v-icon small>mdi-content-save</v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    small
                    color="grey"
                    @click="cancelarEdicionPoliza"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </div>

              </template>

              <!-- VISUALIZACIÓN -->
              <template v-else>

                <v-tooltip
                  bottom
                  :disabled="!item.nombre_usuario_poliza && !item.fecha_poliza"
                >
                  <template v-slot:activator="{ on, attrs }">

                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="text-body-2"
                    >
                      {{ item.poliza || '—' }}
                    </span>

                  </template>

                  <div>
                    <div>
                      <strong>Usuario:</strong>
                      {{ item.nombre_usuario_poliza || 'N/D' }}
                    </div>

                    <div>
                      <strong>Fecha:</strong>
                      {{ item.fecha_poliza || 'N/D' }}
                    </div>
                  </div>

                </v-tooltip>

                <v-btn
                  icon
                  small
                  color="primary"
                  @click="editarPoliza(item)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>

              </template>

            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'
import Detalles from './Facturas/Detalles.vue'
import Servidores from './Facturas/Servidores.vue'
import { mapState } from 'vuex'

export default {
  components: {
    VAlertDialog,
    Detalles,
    Servidores
  },
  computed: {
    ...mapState(['token']),
  },
  data: () => ({
    dialogPrograma: false,
    tabPrograma: 0,
    dialogCargando: false,
    archivoSeleccionado: null,
    loadingCargar: false,
    loading: false,
    ultima_actualizacion: null,
    facturas: [],
    headers: [
      { text: 'UUID', value: 'id_uuid_factura', sortable: false },

      { text: 'Póliza', value: 'poliza', width: '10%'},

      { text: 'Estado SAT', value: 'estado_sat' },
      { text: 'Tipo', value: 'tipo' },

      { text: 'Serie', value: 'serie' },
      { text: 'Folio', value: 'folio' },

      { text: 'Fecha Emisión', value: 'fecha_emision' },
      { text: 'Fecha Timbrado', value: 'fecha_timbrado' },

      { text: 'RFC Emisor', value: 'rfc_emisor' },
      { text: 'Emisor', value: 'nombre_emisor' },
      { text: 'Régimen Fiscal Emisor', value: 'regimen_fiscal_emisor' },

      { text: 'RFC Receptor', value: 'rfc_receptor' },
      { text: 'Receptor', value: 'nombre_receptor' },
      { text: 'Régimen Fiscal Receptor', value: 'regimen_fiscal_receptor' },

      { text: 'Uso CFDI', value: 'uso_cfdi' },

      { text: 'Moneda', value: 'moneda' },
      { text: 'Tipo Cambio', value: 'tipo_de_cambio' },

      { text: 'Subtotal', value: 'sub_total', align: 'right' },
      { text: 'Descuento', value: 'descuento', align: 'right' },
      { text: 'Impuestos', value: 'impuestos' },
      { text: 'Total', value: 'total', align: 'right' },

      { text: 'Forma Pago', value: 'forma_de_pago' },
      { text: 'Método Pago', value: 'metodo_de_pago' },

      { text: 'Combustible', value: 'combustible' },

      { text: 'UUID Relacionados', value: 'relaciones' },    

      { text: 'Fecha Cancelación', value: 'fecha_cancelacion' }
    ],

    editingPolizaId: null,
    polizaDrafts: {},
    savingPoliza: false,

    // Filtros
    menuFechaDesde: false,
    menuFechaHasta: false,
    opcionesTipo: [
      { text: 'Recibidos', value: 1 },
      { text: 'Emitidos', value: 2 }
    ],
    filters: {
      tipo: 1,
      fecha_emision_desde: null,
      fecha_emision_hasta: null,
      rfc: null,
      nombre: null,
      monto_desde: null,
      monto_hasta: null,
      iva_retencion: false,
      isr_retencion: false
    },
  }),
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true;
      
      // Limpiamos los filtros para no enviar nulos o vacíos innecesarios
      const params = {};
      Object.keys(this.filters).forEach(key => {
        const value = this.filters[key];
        if (value !== null && value !== '' && value !== false) {
          params[key] = value;
        }
      });

      axios
        .get('/Pagos/ListarFacturas', { params }) // Axios envía esto como query string
        .then(response => {
          this.facturas = response.data.facturas;
          this.ultima_actualizacion = response.data.ultima_actualizacion;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    exportarExcel() {
      // 1. Definir la base de la API
      const baseUrl = '/api/Pagos/ExportarFacturasExcel';

      // 2. Construir los Query Params basados en los filtros actuales
      const params = new URLSearchParams();

      // Agregamos el token si es necesario para la autenticación
      if (this.token) {
        params.append('jwt', this.token);
      }

      // Mapeamos los filtros (solo los que tengan valor)
      Object.keys(this.filters).forEach(key => {
        const value = this.filters[key];
        if (value !== null && value !== '' && value !== false) {
          params.append(key, value);
        }
      });

      // 3. Generar la URL final
      const urlFinal = `${baseUrl}?${params.toString()}`;

      // 4. Ejecutar la descarga
      // Usamos window.open para que el navegador gestione la descarga del archivo xlsx
      window.open(urlFinal, '_blank');
    },

    limpiarFiltros() {
      this.filters = {
        tipo: 1,
        fecha_emision_desde: null,
        fecha_emision_hasta: null,
        rfc: null,
        nombre: null,
        monto_desde: null,
        monto_hasta: null,
        iva_retencion: false,
        isr_retencion: false
      };
      this.getItems();
    },
    cargarArchivo() {
      if (!this.archivoSeleccionado) {
        this.$refs.alert.setMessage("", "Debe seleccionar un archivo")
        this.$refs.alert.open()
        return
      }

      this.loadingCargar = true
      this.dialogCargando = true

      const formData = new FormData()
      formData.append('archivo', this.archivoSeleccionado)

      axios
        .post('/Pagos/CargaFacturasSat', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
          this.archivoSeleccionado = null
          this.getItems()
          this.$refs.alert.setMessage("", "Facturas cargadas exitosamente")
          this.$refs.alert.open()
        })
        .catch(error => {
          this.$refs.alert.setMessage("", "Error al cargar el archivo")
          this.$refs.alert.open()
          console.log(error)
        })
        .finally(() => {
          this.loadingCargar = false
          this.dialogCargando = false
        })
    },
    descargarPrograma() {
      // Aquí iría la lógica para descargar el programa
      window.open(`/api/Pagos/DescargarInstalador/descarga-masiva-sat-v1.0.exe?jwt=${this.token}`, '_blank')
    },
    verDetalles(id_uuid_factura) {
      this.$refs.detalles.open(id_uuid_factura)
    },
    verServidores() {
      this.$refs.servidores.open()
    },
    formatMoney(value) {
      if (value == null) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    editarPoliza(item) {
      this.editingPolizaId = item.id_uuid_factura

      this.$set(
        this.polizaDrafts,
        item.id_uuid_factura,
        item.poliza || ''
      )
    },

    cancelarEdicionPoliza() {
      this.editingPolizaId = null
    },

    guardarPoliza(item) {

      const poliza = this.polizaDrafts[item.id_uuid_factura].trim()

      if(poliza == null || poliza.length < 1){
        this.$refs.alert.setMessage('', 'Debe capturar al menos un carácter para la póliza.');
        this.$refs.alert.open();
        return;
      }

      this.savingPoliza = true

      axios
        .post('/Pagos/ActualizarPolizaFactura', {
          id_uuid_factura: item.id_uuid_factura,
          poliza: poliza
        })
        .then(response => {

          item.poliza = poliza

          if (response.data) {
            item.nombre_usuario_poliza =
              response.data.nombre_usuario_poliza

            item.fecha_poliza =
              response.data.fecha_poliza
          }

          this.editingPolizaId = null
        })
        .catch(error => {

          console.log(error)

          this.$refs.alert.setMessage(
            '',
            'Error al actualizar la póliza'
          )

          this.$refs.alert.open()

        })
        .finally(() => {
          this.savingPoliza = false
        })
    },
    updateProgress(){
      this.getItems();
    },
  }
}
</script>